export const CHANNEL = {
  API: 1,
  PLANTILLA: 2,
  MANUAL: 3,
  MASIVA: 4,
};
export const EVENT = {
  'APERTURA_PUERTA': 101,
  'DETENCION_EXCESIVA': 102,
  'EXCESO_VELOCIDAD': 103,
  'EXCESO_VELOCIDAD_FLOTA': 104,
  'DESCONEXION_ELECTRICA': 105,
  'PERDIDA_UBICACION_GPS': 106,
  'SALIDA_RUTA': 107,
  'INTEREFERENCIA_GPS': 108,
  'BOTON_PANICO': 109,
};